export default "__VITE_ASSET__6a654c92__"